module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAApCAYAAADeWrJ9AAABAElEQVRIibXXOw6CQBSF4YMYF0GnDetiMXZWLkF73YFuQ0sbF2FCjg2jEzIwcx/cxBAG8v2ANFQk4TjNsH0DwMoZvgG4/yIkPX4NyQf/8yTZVA6PJVxxO1o/el9xmCvJzWIwSfUzz8JavAjW4MWwFBfBElwMl+IquARXwzncBM/hZngKn4IvEjiFu8Fj3BWOcXc44IvAAd8n4A/J1gIHvCZ5SgReJLdWfLFAvOMeGC+4BlKLboGpAy6BuYPmQO4EU6Dk9tSB0j9HFZC8WuKA6L2VBqS4KKDBiwNavChgwXOBnRWfCxw88FTgTLJeWz+IhukBdNF+B6D3+OCKp45i+AJiE4I434BCpgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/back.png
// module id = 0YUB
// module chunks = 1